import axios from 'axios';
import { logger } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';
import { CollectionFormFields } from '../types';
import { isCollectionKimeraError } from '../utils/isCollectionKimeraError';

const getUrl = (id: string) => pathfinder('edit_collection', { id });

export const updateCollection = async (id, collection: CollectionFormFields) => {
    try {
        const response = await axios.put<void>(getUrl(id), collection);
        return response.data;
    } catch (error) {
        if (!isCollectionKimeraError(error)) {
            logger.error(error as Error, { description: 'Failed to update collection' });
        }
        throw error;
    }
};
